








 import source from './demo1.txt';
 import md from '@/packages/m-checkbox/demo/demo1/index.md';
 import Vue from 'vue';
 import Component from 'vue-class-component';
 import CodeBox from '../../components/code-box.vue';
 import DemoComp from '@/packages/m-checkbox/demo/demo1/index.vue';

 @Component({
   name: 'Demo1',
   components: {CodeBox, DemoComp}
})
 export default class Demo1 extends Vue {
   public code = source;
   public md = md;
 }
